import React, { useEffect, useState } from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input/input';
import { DatePicker, notification } from 'antd';
import Select from 'react-select';

import { allergyList, genders2, gendersTwo, getgendersdisplay, gradeArr, groupCodeGenerate, medicalList, removeTime, resHandle, shortsAndTshirtSizes, _calculateAge, provinceList } from '../../helper';
import moment from 'moment';
import { participantAdd, deleteCamper, uploadMedia } from '../../services/campersServices';
import { MiniLoader, PDFIcon } from '../reuse/SVG';
import ConfirmModal from '../modals/ConfirmModal';
import EditCamperModal from './EditCamperModal';
import {InputTextError } from '../reuse/FormControls';
import AddCamperModal from '../modals/AddNewCamper';

const dateFormatNew = 'MM/DD/YYYY';

const CamperInfo = props => {
    const [campers, setCampers] = useState([]);
    const [addCamperModal, setAddCamperModal] = useState(false);
    const [newCampers, setNewCampers] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [btnloader, setBtnloader] = useState(false);
    const [errormodal, setErrorModel] = useState(false);
    const [errIndexCamper, setErrIndexCamper] = useState(0);
    const [confirmModal, setConfirmModal] = useState(false);
    const [currentId, setCurrentId] = useState('');
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [activeCamper, setActiveCamper] = useState({});
    const [miniLoader, setMiniLoader] = useState({});

    useEffect(() => {
        if(props?.data?._id){
            setCampers(props.data.campersData || []);
        }

    }, [props?.data])


    const handleClose = () => {
        setAddCamperModal(false);
        setNewCampers([]);
    }

    const handleAddNewCamperModal = () => {
        let newCamper = {
            activityInterest: [],
            address: '',
            allergy: '',
            allergyDeadly: '',
            allowDocumentCamper: '',
            apartment: '',
            camperId: props?.match?.params?.id ? props.match.params.id : props.userId,
            city: '',
            currentGrade: '',
            dob: '',
            firstName: '',
            gender: '',
            group: '',
            groupcode: groupCodeGenerate(),
            lastName: '',
            medical: '',
            medicalDocument: '',
            medicalDocumentLoader: '',
            medicalInsuranceCompany: '',
            medicationsTaken: '',
            participantBringingOwnMedication: '',
            participantReceiveCounterMedication: '',
            permissionEmergencyMedication: '',
            physicianAddress: '',
            policyNumber: '',
            primaryPhysician: '',
            profileImage: '',
            shortsSize: '',
            state: '',
            tshirtSize: '',
            zipCode: '',
        }

        let temp = [...newCampers];
        temp.push(newCamper);
        setNewCampers(temp);
        setAddCamperModal(true);
    }


    const handleChange = (e, i) => {
        let { name, value } = e.target;
        if(value !== undefined && value !== null){
            let temp = [...newCampers];
            temp[i][name] = value;
            temp[i][`${name}Err`] = '';
            setNewCampers(temp);
        } 
    }

    const handleRadioChange = (e, i) => {

        let { name, value } = e.target;
            let temp = [...newCampers];
            temp[i][name] = Number(value);
            setNewCampers(temp);
    }


    const handlePhoneChange = (e, b, i) => {
        if(e !== undefined && e !== null){
            let temp = [...newCampers];
            temp[i][b] = e;
            setNewCampers(temp);
        } 
    }


    const handleCheckBoxChange = (e, i, b) => {
        let { name } = e.target;
        let temp = [...newCampers];
            temp[i][name] = b;
            temp[i][`${name}Err`] = '';
            setNewCampers(temp);
    }


    const handleDateChange = (e, b, i) => {
        if(e !== undefined && e !== null){
            let temp = [...newCampers];
            temp[i][b] = new Date(removeTime(e._d)).getTime();
            temp[i][`${b}Err`] = '';
            setNewCampers(temp);
        } 
    }

    const handleSelectChange = (e, b, i) => {
        if(e !== undefined && e !== null){
            let temp = [...newCampers];
            temp[i][b] = e.value;
            temp[i][`${b}Err`] = '';
            setNewCampers(temp);
        } 
    }

    const handleMultiSelectChange = (e, b, i) => {
        let temp = [...newCampers];
        if(e !== undefined && e !== null){
            let isNone = e.find(m => m.value === 'None');
            if(isNone){
                temp[i][b] = [isNone.value];
                if(b === 'allergy'){
                    temp[i].allergyDeadly = '2'; 
                }
            }else{
                temp[i][b] = e.map(m => m.value);
            }
        }else{
            temp[i][b] = []; 
        }
        temp[i][`${b}Err`] = '';
        setNewCampers(temp);
    }


    const uploadHippaCompliance = (e, b, i, d) => {
        const data = new FormData();
        data.append('file', e.target.files[0]);
        let temp = [...newCampers];
        temp[i][d] = true;
        setNewCampers(temp);
        uploadMedia(data).then(res => {
            if(res.data.responseData.result.fileUrl !== undefined){
                let temp = [...newCampers];
                temp[i][b] = res.data.responseData.result.fileUrl;
                temp[i][d] = false;
                setNewCampers(temp);
            }
        })
    }

    const handleFileChange = (e, i) => {
        const data = new FormData();
        data.append('file', e.target.files[0]);
        setMiniLoader({[i]: true});
        uploadMedia(data).then(res => {
            if(res.data.responseData.result.fileUrl !== undefined){
                let temp = [...newCampers];
                temp[i].profileImage = res.data.responseData.result.fileUrl;
                setNewCampers(temp);
                setMiniLoader({[i]: false});
            }
        })
    }  




    const handleRemoveMedicalDocument = (b, i) => {
        let temp = [...newCampers];
        temp[i][b] = '';
        setNewCampers(temp);
    }


    const  disabledDate = (current) => {
        return current && (current > moment().startOf('day') || current < moment(`${new Date().getFullYear() - 100}-10-23`).startOf('day'));
    }


    const handleSubmit = () => {
        
        let errors = newCampers.map((item, ind) => {
            let errObj = {};

            if (item.firstName === '')        {errObj.firstNameErr = 'First name is required'}
            if (item.lastName === '')         {errObj.lastNameErr = 'Last name is required'}
            if (item.dob === '')              {errObj.dobErr = 'Date of birth is required'}
            if (item.currentGrade === '')     {errObj.currentGradeErr = 'Grade is required'}
            if (item.gender === '')           {errObj.genderErr = 'Gender is required'}
            if (item.address === '')          {errObj.addressErr = 'Address is required'}
            if (item.city === '')             {errObj.cityErr = 'City is required'}
            if (item.zipCode === '')          {errObj.zipCodeErr = 'Zip code is required'}
            if (item.zipCode?.length < 5)    {errObj.zipCodeErr = 'The zip code must be at least 5 digits long.'}
            if (item.state === '')            {errObj.stateErr = 'State is required'}
            if (item.shortsSize === '')       {errObj.shortsSizeErr = 'Shorts size is required'}
            if (item.tshirtSize === '')       {errObj.tshirtSizeErr = 'Tshirt size is required'}
            if (item.medical?.length === 0)   {errObj.medicalErr = 'Medical is required'}
            if (item.allergy?.length === 0)   {errObj.allergyErr = 'Allergy is required'}
            if (item.allergyDeadly === '')    {errObj.allergyDeadlyErr = 'Allergy deadly is required'}


            let isValidate = false;

            if(Object.keys(errObj).length === 0){
                isValidate = true
            }
            errObj.isValidate = isValidate;

            return {...item, ...errObj}
        })
        
        let finalValidCheck = errors.filter(i => i.isValidate === false);


        if(finalValidCheck.length === 0){
            setBtnloader(true);
            let finalCampers = newCampers.map(i => ({
                ...i,
                allergy: JSON.stringify(i.allergy),
                medical: JSON.stringify(i.medical),
            }))

            let params = {deviceTypeID:3, participants: JSON.stringify(finalCampers)}
            participantAdd(params).then(res => {
                setBtnloader(false);
                let { status, data } = resHandle(res);
                   if(status){
                    setAddCamperModal(false);
                    setNewCampers([]);
                    setActiveIndex(0);
                    props.callback();
                   }
                
                notification.open({
                    message: 'Participants',
                    description:
                      'Participants added successfully',
                  });
            })
        }else{
            let _errIndexCamper = ''
            for (let i = 0; i < errors.length; i++) {
                if(errors[i].isValidate === false){
                    _errIndexCamper = i;
                    break;
                }
              }

              if(_errIndexCamper !== ''){
                setErrIndexCamper(_errIndexCamper)
              }

            setNewCampers(errors);
            setErrorModel(true);
        }
        
     }


     const handleDelete = () => {
        let query = `/?camperId=${currentId}`;
        deleteCamper(query).then(res => {
            setConfirmModal(false);
            let { status, data } = resHandle(res);
            if(status){
                props.callback();
            }
        })
     }


     const handleCloseEditModal = () => {
        setIsEditModalOpen(false);
        props.callback();
     }


     const handleRemove = ind => {
        let _newCampers = [...newCampers];
        _newCampers.splice(ind, 1);
        setNewCampers(_newCampers);
        setActiveIndex(ind - 1)
     }





    return(
        <div className="mt-3 ms-3 me-3">
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4>Participant(s)</h4>
                <button className='btn btn-primary' onClick={handleAddNewCamperModal}>Add new participant</button>
            </div>

            {isEditModalOpen ? 
            <EditCamperModal
                isOpen={isEditModalOpen}
                data={activeCamper}
                closeEditModal={handleCloseEditModal} 
            /> : ''}


            


            <ConfirmModal
                show={confirmModal}
                hideModal={() => setConfirmModal(false)}
                msg="Are you sure you want to delete?"
                action={handleDelete} />

            <ul className='campers_list'>
                {
                    campers.map(item => (
                        <li key={item._id}>
                            <img src={item.profileImage || require('../../assets/img/user.png')} />
                            <div>
                                <p>{item.firstName} {item.lastName}</p>
                                <p><b>Group code: </b>{item.groupcode} <b>Age: </b> {_calculateAge(item.dob)} <b>Sex: </b> {getgendersdisplay(item.gender)}</p>
                            </div>
                            <div>
                                <i className="icon-pancil" onClick={() => (setActiveCamper(item), setIsEditModalOpen(true))} />
                                <i className="icon-delete" onClick={() => (setConfirmModal(true), setCurrentId(item._id))}  />
                            </div>
                        </li>
                    ))
                }
            </ul>




            {addCamperModal && 
            <AddCamperModal
                show={addCamperModal}
                handleClose={handleClose}
                handleAddNewCamperModal={handleAddNewCamperModal}
                newCampers={newCampers}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
                handleFileChange={handleFileChange}
                miniLoader={miniLoader}
                handleRemove={handleRemove}
                handleChange={handleChange}
                handleDateChange={handleDateChange}
                handleSelectChange={handleSelectChange}
                handleCheckBoxChange={handleCheckBoxChange}
                handleMultiSelectChange={handleMultiSelectChange}
                handleRadioChange={handleRadioChange}
                handlePhoneChange={handlePhoneChange}
                uploadHippaCompliance={uploadHippaCompliance}
                handleRemoveMedicalDocument={handleRemoveMedicalDocument}
                handleSubmit={handleSubmit}
                btnloader={btnloader}
                gradeArr={gradeArr}
                gendersTwo={gendersTwo}
                provinceList={provinceList}
                shortsAndTshirtSizes={shortsAndTshirtSizes}
                medicalList={medicalList}
                allergyList={allergyList}
                disabledDate={disabledDate}
                dateFormatNew={dateFormatNew}
                errormodal={errormodal}
                setErrorModel={setErrorModel}
                errIndexCamper={errIndexCamper}
            />}
        </div>
    )
}

export default CamperInfo;